<template>
  <menu-dropdown bodyClass="right-0 cursor-default">
    <template #title>
      <div v-if="showAbbr" class="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
        <span class="font-medium text-gray-600 dark:text-gray-300">{{ profile_abbr }}</span>
      </div>
      <img v-else :src="profile_url" width="30" height="30" class="rounded-full mr-5" @error="onProfileImageError" />
    </template>
    <div v-if="isLoggedIn">
      <div class="font-bold text-base">{{ name }}</div>
      <div class="font-semibold text-gray-400">{{ profile.location_descr }}</div>
      <slot> </slot>

      <div class="border-t border-gray-200 mt-3 mb-4 mx-1"></div>
      <a @click="signout" class="cursor-pointer -m-3 p-3 rounded-md transition ease-in-out duration-150 hover:bg-indigo-50 flex gap-2 items-center">
        <log-out-icon class="mr-1" />
        Sign out
      </a>
    </div>
    <div v-else>
      <a @click="signin" class="cursor-pointer -m-3 p-3 rounded-md transition ease-in-out duration-150 hover:bg-indigo-50 flex gap-2 items-center">
        <log-in-icon class="mr-1" />
        Sign in
      </a>
    </div>
  </menu-dropdown>
</template>

<script>
import MenuDropdown from './MenuDropdown.vue'
import cookie from 'js-cookie'
import store from 'store'
import { LogOutIcon, LogInIcon } from 'vue-feather-icons'

const baseDomain = location.hostname.split('.').slice(-2).join('.')
const apiDomain = `newsdesk-api.${baseDomain}`
const loginUrl = import.meta.env.VITE_LOGIN_URL ?? `https://${apiDomain}/okta/login`

export default {
  components: {
    MenuDropdown,
    LogOutIcon,
    LogInIcon
  },
  data() {
    return {
      show: false,
      profile: {},
      showAbbr: false
    }
  },
  props: {
    /**
     * Indicate if we should require an authenticated employee before loading the content.
     */
    requireAuth: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    // parse JWT to get user profile
    const token = cookie.get('EWS_AUTH_KEY')

    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      this.profile = payload.data
    }
  },
  computed: {
    name() {
      return this.profile ? `${this.profile.first_name} ${this.profile.last_name}` : ''
    },
    isLoggedIn() {
      return !!this.profile?.empid
    },
    profile_url() {
      let empid = this.profile?.empid || '99'

      // set cache buster to start of today
      let now = new Date()
      let startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      let ts = startOfDay / 1000

      return `//worklife.scrippsnet.com/utils/photo/75/${empid}/${ts}.jpg`
    },
    profile_abbr() {
      return this.profile ? `${this.profile.first_name?.[0] || ''}${this.profile.last_name?.[0] || ''}` : '-'
    }
  },
  methods: {
    signin() {
      // redirect to the login screen
      const prev = encodeURIComponent(location.href)
      window.location.href = `${loginUrl}?prev=${prev}`
    },
    signout() {
      // remove EWS_AUTH_KEY
      cookie.remove('EWS_AUTH_KEY', { path: '/', domain: `.${baseDomain}` })

      // remove ANY localStorage starting with "ews_"
      store.each(function (value, key) {
        if (key.startsWith('ews_')) {
          store.remove(key)
        }
      })

      if (this.requireAuth) {
        // redirect to the login screen
        const prev = encodeURIComponent(location.href)
        window.location.href = `${loginUrl}?prev=${prev}`
      } else {
        window.location.href = location.href
      }
    },
    onProfileImageError() {
      this.showAbbr = true
    }
  }
}
</script>

<style lang="postcss"></style>
